// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/nav-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student_login {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background-color: #2d3e97;
}
.student_login::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top right;
  background-size: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 992px) {
  .student_login::before {
    background-size: 280%;
  }
}
.student_login .student_block {
  position: relative;
  z-index: 2;
}
.student_login .student_block .student-login-register {
  position: relative;
}
@media (max-width: 992px) {
  .student_login .student_block .student-login-register .navbar-collapse.show {
    background: #232f73 !important;
  }
}
.student_login .student_block .student-login-register .top-navbar {
  padding: 0.45rem 1rem;
}
.student_login .student_block .student-login-register .top-navbar a {
  color: #ffffff;
  text-decoration: none;
  font-family: "Titillium Web", sans-serif;
}
@media (min-width: 1200px) {
  .student_login .student_block .student-login-register .top-navbar a {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
.student_login .student_block .student-login-register .top-navbar a:last-child {
  border-right: 0;
}
.student_login .student_block .student-login-register .top-navbar a.active {
  color: #fff;
}
.student_login .student_block .title-sections {
  margin-top: 2rem;
  margin-bottom: 6rem;
}
@media (max-width: 992px) {
  .student_login .student_block .title-sections {
    margin-bottom: 10rem;
  }
}
.student_login .student_block main {
  position: relative;
  background: #ffffff;
  padding-bottom: 3rem;
}
.student_login .student_block main .form_card {
  position: relative;
  margin-top: -12rem;
  border-radius: 15px;
  box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);
  z-index: 2;
}
.student_login .student_block main .form_card img {
  margin-top: -9rem;
}
@media (max-width: 767px) {
  .student_login .student_block main .form_card img {
    margin-top: 0;
    width: 250px;
  }
}
.student_login .student_block .student_footer {
  position: relative;
  background: #333333;
}
@media (max-width: 767px) {
  .student_login .student_block .student_footer {
    text-align: center;
  }
}
.student_login .student_block .student_footer .footer-top {
  background: #393939;
}
.student_login .student_block .student_footer .footer-top .import-link li {
  margin-right: 2rem;
}
.student_login .student_block .student_footer .footer-top .import-link li:last-child {
  margin-right: 0;
}
.student_login .student_block .student_footer .footer-top .social-list li {
  margin-right: 1rem;
}
.student_login .student_block .student_footer .footer-top .social-list li:last-child {
  margin-right: 0;
}
.student_login .student_block .student_footer .footer-middle .import-link2 li {
  margin-right: 3rem;
}
.student_login .student_block .student_footer .footer-middle .import-link2 li:last-child {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/login_register/_studentlogin.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AACF;AACE;EACE,WAAA;EACA,uEAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AACJ;AACI;EAVF;IAWI,qBAAA;EAEJ;AACF;AACE;EACE,kBAAA;EACA,UAAA;AACJ;AACI;EACE,kBAAA;AACN;AACM;EACE;IACE,8BAAA;EACR;AACF;AAEM;EACE,qBAAA;AAAR;AAEQ;EACE,cAAA;EACA,qBAAA;EACA,wCAAA;AAAV;AAEU;EALF;IAMI,6BAAA;IACA,8BAAA;EACV;AACF;AACU;EACE,eAAA;AACZ;AAEU;EACE,WAAA;AAAZ;AAMI;EACE,gBAAA;EACA,mBAAA;AAJN;AAMM;EAJF;IAKI,oBAAA;EAHN;AACF;AAMI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AAJN;AAMM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,UAAA;AAJR;AAMQ;EACE,iBAAA;AAJV;AAMU;EACE;IACE,aAAA;IACA,YAAA;EAJZ;AACF;AAUI;EACE,kBAAA;EACA,mBAAA;AARN;AAUM;EAJF;IAKI,kBAAA;EAPN;AACF;AASM;EACE,mBAAA;AAPR;AASQ;EACE,kBAAA;AAPV;AASU;EACE,eAAA;AAPZ;AAWQ;EACE,kBAAA;AATV;AAWU;EACE,eAAA;AATZ;AAeQ;EACE,kBAAA;AAbV;AAeU;EACE,eAAA;AAbZ","sourcesContent":[".student_login {\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background-color: #2d3e97;\n\n  &::before {\n    content: \"\";\n    background: url(\"../../../images/nav-bg.png\") no-repeat top right;\n    background-size: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n\n    @media (max-width: 992px) {\n      background-size: 280%;\n    }\n  }\n\n  .student_block {\n    position: relative;\n    z-index: 2;\n\n    .student-login-register {\n      position: relative;\n\n      @media (max-width: 992px) {\n        .navbar-collapse.show {\n          background: #232f73 !important;\n        }\n      }\n\n      .top-navbar {\n        padding: 0.45rem 1rem;\n\n        a {\n          color: #ffffff;\n          text-decoration: none;\n          font-family: \"Titillium Web\", sans-serif;\n\n          @media (min-width: 1200px) {\n            padding-left: 20px !important;\n            padding-right: 20px !important;\n          }\n\n          &:last-child {\n            border-right: 0;\n          }\n\n          &.active {\n            color: #fff;\n          }\n        }\n      }\n    }\n\n    .title-sections {\n      margin-top: 2rem;\n      margin-bottom: 6rem;\n\n      @media (max-width: 992px) {\n        margin-bottom: 10rem;\n      }\n    }\n\n    main {\n      position: relative;\n      background: #ffffff;\n      padding-bottom: 3rem;\n\n      .form_card {\n        position: relative;\n        margin-top: -12rem;\n        border-radius: 15px;\n        box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);\n        z-index: 2;\n\n        img {\n          margin-top: -9rem;\n\n          @media (max-width: 767px) {\n            & {\n              margin-top: 0;\n              width: 250px;\n            }\n          }\n        }\n      }\n    }\n\n    .student_footer {\n      position: relative;\n      background: #333333;\n\n      @media (max-width: 767px) {\n        text-align: center;\n      }\n\n      .footer-top {\n        background: #393939;\n\n        .import-link li {\n          margin-right: 2rem;\n\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n\n        .social-list li {\n          margin-right: 1rem;\n\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n\n      .footer-middle {\n        .import-link2 li {\n          margin-right: 3rem;\n\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
